module.exports = __webpack_public_path__ + "img/Rectangle.fc242f6d.png";